import React, {Component} from 'react';
import {observer} from 'mobx-react';

@observer
class CoinDetailRow extends Component {
    render() {
        let coinData = this.props.coinData;
        let formatter = new Intl.NumberFormat('en-US', {
            style: 'decimal',
            maximumFractionDigits: 20,
        });
        let currencySymbol = this.props.appState.currency.prefix;

        return (


            <tbody>
                <tr>
                    <td className="left-padding left">{currencySymbol}{ formatter.format(coinData.cap) }</td>
                    <td className="left">{currencySymbol}{ formatter.format(coinData.volume) } </td>
                </tr>
            </tbody>
        );
    }
}

export default CoinDetailRow;



// WEBPACK FOOTER //
// ./src/CoinDetailRow.js